import { JsonApiService } from '@app/core/services/Common/json-api.service';
import { BehaviorSubject, of, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import * as moment from 'moment';

import { QuotationPolicyHolder } from '@app/shared/models/business/life/quotation.policyholder.model';
import { QuotationState } from '@app/shared/models/dto/quotation.state.model';

import * as AspNetData from "devextreme-aspnet-data-nojquery";
import CustomStore from "devextreme/data/custom_store";

import { Router, ActivatedRoute } from '@angular/router';

import { QuotationBenefitsReview } from '@app/shared/models/business/life/quotation.benefit.review';
import { IndustryType } from '@app/shared/models/business/life/industrytype.model';
import { ApiResponse } from '@app/shared/models/Common/apiresponse.model';
import { QuotationLoading } from '@app/shared/models/business/life/quotation.loading';
import { Product } from '@app/shared/models/business/product';
import { QuotationApprovalRequest } from '@app/shared/models/business/life/quotation.approvalrequest';
import { map } from 'rxjs/operators';
import { QuotationDocument } from '@app/shared/models/business/life/quotation.document';
import { QuotationNRPLoading } from '@app/shared/models/business/life/quotation.nrploading';
import { QuotationApprovalComment } from '@app/shared/models/business/life/quotation.approvalcomment';
import { CalculationSummaryDto } from '@app/shared/models/business/life/quotation.calculationsummary';
import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { LifeQuotationEndpoint } from '@app/core/endpoints/life/life-quotation-endpoint.service';
import { AuthService } from '../../auth/auth.service';

@Injectable()
export class LifeQuotationService {




	private sourceQuotationState = new BehaviorSubject<QuotationState>(new QuotationState());
	quotationState = this.sourceQuotationState.asObservable();

	url_base: string;
	tenantId: number;
	userTenantCode: string;
	constructor(
		private jsonApiService: JsonApiService,
		private quotationEndpoint: LifeQuotationEndpoint,
		private authService: AuthService,
		private router: Router,
		private route: ActivatedRoute,
	) {
		this.url_base = '/quotation/';
		this.tenantId = this.authService.tenantId;
		this.userTenantCode = this.authService.tenantCode;
	}

	setQuotationState(quotState: QuotationState): void {
		this.sourceQuotationState.next(quotState);
	}
	getQuotationState(): QuotationState {
		return this.sourceQuotationState.value;
	}

	getPolicyHolders(): CustomStore {
		return this.quotationEndpoint.getPolicyHolders(this.authService.tenantId);
	}
	getBusinessEntities(entityType: string): CustomStore {
		return this.quotationEndpoint.getBusinessEntities(entityType, this.authService.tenantId);
	}
	getQuotingInsurer() {
		return this.quotationEndpoint.getQuotingInsurer(this.authService.tenantId);
	}
	getExpQuotingInsurer() {
		return this.quotationEndpoint.getExpQuotingInsurer(this.authService.tenantId);
	}
	getQuotingTPA(): Observable<any> {
		return this.quotationEndpoint.getQuotingTPA<any>();
	}
	// getBusinessSectors(): CustomStore {
	// return this.quotationEndpoint.getBusinessSectorList(this.tenantId);
	// }
	getBusinessSectors() {
		return this.quotationEndpoint.getbusinessSectorEndpoint<IndustryType[]>(this.tenantId);
	}

	getPolicyholderList() {
		return this.jsonApiService.fetch(this.url_base + 'companies.json');
	}
	initializeQuotation(quot: QuotationPolicyHolder) {
		return this.quotationEndpoint.getInitQuotationEndpoint<ApiResponse>(quot);
	}
	getHealthLifeQuotation(sourceQuotationId: number): Observable<any> {
		return this.quotationEndpoint.getHealthLifeQuotationEndpoint<any>(sourceQuotationId)
	}
	uploadCensus(census: any): Observable<ApiResponse> {
		return this.quotationEndpoint.uploadCensusEndpoint<ApiResponse>(census);
	}
	uploadMiscDocument(document: any): Observable<ApiResponse> {
		return this.quotationEndpoint.uploadMiscDocumentEndpoint<ApiResponse>(document);
	}
	uploadDependentsDocument(document: any): Observable<ApiResponse> {
		return this.quotationEndpoint.uploadDependentsDocumentEndpoint<ApiResponse>(document);
	}
	uploadWcDocument(document: any): Observable<ApiResponse> {
		return this.quotationEndpoint.uploadWcDocumentEndpoint<ApiResponse>(document);
	}
	submitForApproval(quotationId: number) {
		return this.quotationEndpoint.submitForApprovalEndpoint<ApiResponse>(quotationId);
	}
	getSubmissionElements(quotationId: number): Observable<any> {
		return this.quotationEndpoint.getSubmissionElements<any>(quotationId);
	}
	submitForApprovalWithLoading(obj: any): Observable<ApiResponse> {
		return this.quotationEndpoint.submitForApprovalWithLoading<ApiResponse>(obj);
	}
	draftTermsQuotations(obj: any): Observable<ApiResponse> {
		return this.quotationEndpoint.draftTermsQuotations<ApiResponse>(obj);
	}
	getIndicativePremium(obj: any): Observable<any> {
		return this.quotationEndpoint.getIndicativePremium<any>(obj);
	}
	getIndicativePremiumForApprover(obj: any): Observable<any> {
		return this.quotationEndpoint.getIndicativePremiumForApprover<any>(obj);
	}
	resetClaimsFactor(quotationId: number): Observable<any> {
		return this.quotationEndpoint.resetClaimsFactor<any>(quotationId);
	}
	getQuotationPolicyHolder(quotationId: number): Observable<QuotationPolicyHolder> {
		return this.quotationEndpoint.getPolicyHolderEndpoint(quotationId);
	}
	getQuotationHeader(insurerId: any): Observable<any> {
		return this.quotationEndpoint.getQuotationHeaderEndPoint<any>(insurerId);
	}
	editQuotationPolicyHolder(formData: QuotationPolicyHolder): Observable<ApiResponse> {
		return this.quotationEndpoint.getEditPolicyHolderEndpoint(formData);
	}
	getGroupTypes(): any {
		return [{ id: 1, text: 'Parent Group', disabled: false }, { id: 2, text: 'Sub Group', disabled: false }];
	}
	getPolicyTypes(): any {
		return [{ id: 1, text: 'Group', disabled: false }, { id: 2, text: 'Individual', disabled: true }];
	}
	getGroupSizes() {
		return [{ id: 1, text: 'Small (<150)', disabled: false }, { id: 2, text: 'Mid (>250)', disabled: false }, { id: 3, text: 'Large (250+)', disabled: false }];
	}
	getProducts(): Observable<Product[]> {
		return this.quotationEndpoint.getProducts<Product[]>();
	}
	getSubProducts(productId: number): Observable<any[]> {
		// return [{id:1,name:'Non CMA Plan'},{id:2,name:'CMA Plan'}];
		return this.quotationEndpoint.getSubProducts(productId);
	}
	getGovernorates(): Observable<any[]> {
		return this.quotationEndpoint.getGovernorateList<any[]>();
	}
	// getQuotationCensusCategories(quotationId: number) {
	// 	return this.censusService.getCensusCategorySummary(quotationId);
	// }
	createNewOption(quotationId: number) {
		return this.quotationEndpoint.createNewOptionEndpoint<number>(quotationId);
	}
	cloneQuotationAsNewInsurer(quotationId: number) {
		return this.quotationEndpoint.cloneQuotationAsNewInsurerEndpoint<number>(quotationId);
	}
	getQuotationBenefit(quotationId: number) {
		return this.quotationEndpoint.getQuotationBenefit<any>(quotationId);
	}
	getBenefitsForComparison(quotationId: number): Observable<QuotationBenefitsReview> {
		return this.quotationEndpoint.getBenefitsForComparison<QuotationBenefitsReview>(quotationId);
	}
	getQuotationWizard() {
		return this.jsonApiService.fetch('/quotation/life/quotationwizard.json?t=' + moment().format('MMDDYYYY'));
	}
	getQuotationAction() {

		return this.jsonApiService.fetch('/quotation/life/quotationaction.json?t=' + moment().format('MMDDYYYY'));
		// .map(p=>JSON.parse(p));
	}
	getQuotationDocName() {
		return this.jsonApiService.fetch('/quotation/life/quotationdocument.json?t=' + moment().format('MMDDYYYY'));
	}
	getAllQuotationList(statusId: any[]): CustomStore {
		return this.quotationEndpoint.getAllQuotationList(this.authService.tenantId, statusId);
	}
	getPendingQuotationList(): CustomStore {
		return this.quotationEndpoint.getPendingQuotationList(this.authService.tenantId);
	}
	 
	getMyDraftQuotationList(statusId: any[]): CustomStore {
		return this.quotationEndpoint.getMyDraftQuotationList(this.authService.tenantId, statusId);
	}
	downloadTOBDoc(quotationId: number): Observable<any> {
		return this.quotationEndpoint.downloadTOBEndpoint(quotationId);
	}
	downloadUWTCDoc(quotationId: number): Observable<any> {
		return this.quotationEndpoint.downloadUWTCDocEndpoint(quotationId);
	}
	downloadPremiumDoc(quotationId: number): Observable<any> {
		return this.quotationEndpoint.downloadPremiumEndpoint(quotationId);
	}
	downloadPremiumTobDoc(quotationId: number): Observable<any> {
		return this.quotationEndpoint.downloadPremiumTobDocEndpoint(quotationId);
	}
	downloadDoc(docId: number): Observable<any> {
		return this.quotationEndpoint.downloadDocumentEndpoint(docId);
	}

	getLoading(quotationId: number): Observable<any> {
		return this.quotationEndpoint.getQuotationLoadingEndpoint<QuotationLoading>(quotationId);
	}
	getQuotationOtherFees(quotationId: number): Observable<any> {
		return this.quotationEndpoint.getQuotationOtherFeesEndPoint<any>(quotationId);
	}
	getQuotationDetail(quotationId: number): Observable<any> {
		return this.quotationEndpoint.getQuotationDetailEndpoint<any>(quotationId)
	}
	getQuotationCensusInfo(quotationId: number): Observable<any> {
		return this.quotationEndpoint.getQuotationCensusInfoEndpoint<any>(quotationId)
	}
	getHealthLifeQuotationDetail(sourceQuotationId: number): Observable<any> {
		return this.quotationEndpoint.getHealthLifeQuotationDetailEndpoint<any>(sourceQuotationId)
	}
	getClientRetention(quotationId: number): Observable<any> {
		return this.quotationEndpoint.getClientRetentionEndpoint<any>(quotationId)
	}

	getQuotationClaimExpSummary(quotationId: number): Observable<any> {
		return this.quotationEndpoint.getQuotationClaimExpSummary<any>(quotationId)
	}

	getQuotationClaimExp(quotationId: number): Observable<any> {
		return this.quotationEndpoint.getQuotationClaimExpEndpoint<any>(quotationId);
	}

	getQuotationOtherBenefits(quotationId: number): Observable<any> {
		return this.quotationEndpoint.getQuotationOtherBenefitsEndPoint<any>(quotationId);
	}

	getCalculationSummary(quotationId: number): Observable<CalculationSummaryDto> {
		return this.quotationEndpoint.getCalculationSummaryEndpoint<CalculationSummaryDto>(quotationId);
	}
	getViewCalculationSummary(quotationId: number): Observable<CalculationSummaryDto> {
		return this.quotationEndpoint.getViewCalculationSummaryEndpoint<CalculationSummaryDto>(quotationId);
	}
	getClaimExpSummary(quotationId: number): Observable<any> {
		return this.quotationEndpoint.getClaimExpSummaryEndpoint<any>(quotationId);
	}
	submitClaimExp(obj: any): Observable<ApiResponse> {
		return this.quotationEndpoint.getSubmitClaimExpEndpoint<ApiResponse>(obj);
	}
	submitApprovalDecision(obj: any): Observable<ApiResponse> {
		return this.quotationEndpoint.submitApprovalDecisionEndPoint<ApiResponse>(obj);
	}
	getApprovalRequest(quotationId: number): Observable<QuotationApprovalRequest> {
		return this.quotationEndpoint.getApprovalRequestEndPoint<QuotationApprovalRequest>(quotationId);
	}
	getQuotationDocuments(quotationId: number): Observable<QuotationDocument[]> {
		return this.quotationEndpoint.getQuotationDocuments<QuotationDocument[]>(quotationId);
	}
	getQuotationDocumentsByType(quotationId: number, docTypeId: string): Observable<QuotationDocument[]> {
		return this.quotationEndpoint.getQuotationDocumentsByType<QuotationDocument[]>(quotationId, docTypeId);
	}
	downloadZip(quotationId: number): Observable<any> {
		return this.quotationEndpoint.downloadZipEndpoint<any>(quotationId);
	}
	downloadCoverNotesZip(quotationId: number): Observable<any> {
		return this.quotationEndpoint.downloadCoverNotesZipEndpoint<any>(quotationId);
	}
	exportQuotation(quotationId: number): Observable<any> {
		return this.quotationEndpoint.exportQuotationEndpoint<any>(quotationId);
	}
	exportQuotationCensusWithAutoOC(quotationId: number): Observable<any> {
		return this.quotationEndpoint.exportQuotationCensusWithAutoOCEndpoint<any>(quotationId);
	}
	exportCoverNotes(quotationId: number): Observable<any> {
		return this.quotationEndpoint.exportCoverNotesEndpoint<any>(quotationId);
	}
	deleteDocument(quotationId: number, docId: number): Observable<ApiResponse> {
		return this.quotationEndpoint.deleteDocument<ApiResponse>(quotationId, docId);

	}
	deleteApprovalDocument(quotationId: number, docId: number): Observable<ApiResponse> {
		return this.quotationEndpoint.deleteApprovalDocument<ApiResponse>(quotationId, docId);

	}
	deleteQuotation(quotationId: number): Observable<ApiResponse> {
		return this.quotationEndpoint.deleteQuotation<ApiResponse>(quotationId);
	}
	confirmQuotation(quotationId: number): Observable<ApiResponse> {
		return this.quotationEndpoint.confirmQuotation<ApiResponse>(quotationId);
	}
	quotationBindCoverNotes(quotationId: number): Observable<ApiResponse> {
		return this.quotationEndpoint.quotationBindCoverNotes<ApiResponse>(quotationId);
	}
	getNRPLoading(quotationId: number): Observable<any> {
		return this.quotationEndpoint.getNRPLoading<any>(quotationId);
	}
	getQuotationApprovalComment(quotationId: number): Observable<QuotationApprovalComment> {
		return this.quotationEndpoint.getQuotationApprovalComment<QuotationApprovalComment>(quotationId);
	}
	//#region Navigation functions
	gotoPolicyHolder() {
		this.router.navigate([`/quote/life/${this.userTenantCode}/policyholder`]);
	}
	gotoCensus() {
		this.router.navigate([`/quote/life/${this.userTenantCode}/census`], { relativeTo: this.route });
	}
	gotoBenefit() {
		this.router.navigate([`/quote/life/${this.userTenantCode}/benefits`], { relativeTo: this.route });
	}
	gotoClaimHistory() {
		this.router.navigate([`/quote/life/${this.userTenantCode}/claimhistory`], { relativeTo: this.route });
	}
	gotoReview() {
		this.router.navigate([`/quote/life/${this.userTenantCode}/review`], { relativeTo: this.route });
	}
	gotoTerms() {
		this.router.navigate([`/quote/life/${this.userTenantCode}/termsconditions`], { relativeTo: this.route });
	}
	gotoSubmitScreen() {
		this.router.navigate([`/quote/life/${this.userTenantCode}/submit`], { relativeTo: this.route });
	}
	gotoPendingApprovals() {
		this.router.navigate(['/life/listing/approval']);
	}
	gotoQuotationListing() {
		this.router.navigate(['/life/listing/quotes']);
	}
	regenerateQuotationDoc(quotationNo: string, isComputePremium: boolean): Observable<ApiResponse> {
		return this.quotationEndpoint.regenerateQuotationDoc<ApiResponse>(quotationNo, isComputePremium);
	}
	gotoChronic() {
		this.router.navigate([`/quote/${this.userTenantCode}/chronic`], { relativeTo: this.route });
	}
	getChronicConditionValues() {
		return this.quotationEndpoint.getChronicConditionValues<any[]>();
	}
	getChronicSubLimit() {
		return this.quotationEndpoint.getChronicSubLimit<any[]>();
	}
	updateChronicConditionValues(chronicCondition: any) {
		return this.quotationEndpoint.updateChronicConditionEndPoint<ApiResponse>(chronicCondition);
	}
	// tslint:disable-next-line: indent
	getQuotationChronicCondition(quotationId: number): Observable<any> {
		return this.quotationEndpoint.getQuotationChronicConditions(quotationId);
	}

	getAgeBasis(): Observable<any[]> {
		return this.quotationEndpoint.getAgeBasis<any[]>();
	}
	getCensusType(): Observable<any[]> {
		return this.quotationEndpoint.getCensusType<any[]>();
	}
	getCoverageType(): Observable<any[]> {
		return this.quotationEndpoint.getCoverageType<any[]>();
	}
	getReInsBasis(): Observable<any[]> {
		return this.quotationEndpoint.getReInsBasis<any[]>();
	}
	getQuotationType(): Observable<any[]> {
		return this.quotationEndpoint.getQuotationType<any[]>();
	}
	getCurrency(): Observable<any[]> {
		return this.quotationEndpoint.getCurrency<any[]>();
	}
	getNewOptionReason(): Observable<any[]> {
		return this.quotationEndpoint.getNewOptionReason<any[]>();
	}
	getRenewalDate(): Observable<any[]> {
		return this.quotationEndpoint.getRenewalDate<any[]>();
	}
	getSourceOfGender(): Observable<any[]> {
		return this.quotationEndpoint.getSourceOfGender<any[]>();
	}
	getOccClassDistType(): Observable<any[]> {
		return this.quotationEndpoint.getOccClassDistType<any[]>();
	}
	getDocumentType(): Observable<any[]> {
		return this.quotationEndpoint.getDocumentType<any[]>();
	}
	getSABasis(): Observable<any[]> {
		return this.quotationEndpoint.getSABasis<any[]>();
	}
	submitAgeBandCensus(obj: any): Observable<ApiResponse> {
		return this.quotationEndpoint.submitAgeBandCensusEndpoint<ApiResponse>(obj);
	}
	saveCensusInfo(obj: any): Observable<ApiResponse> {
		return this.quotationEndpoint.saveCensusInfo<ApiResponse>(obj);
	}
	submitMemberCensus(obj: any): Observable<ApiResponse> {
		return this.quotationEndpoint.submitMemberCensusEndpoint<ApiResponse>(obj);
		// #end region
	}
	getCDApprovers(): Observable<any[]> {
		return this.quotationEndpoint.getCDApprovers<any[]>();
	}
	getSourceQuoteInfoUrl(quotationId: number): Observable<ApiResponse> {
		return this.quotationEndpoint.getSourceQuoteInfoUrlEndpoint<ApiResponse>(quotationId);
	}		  
}
